//Global Functions
window.viewport = function() {
  var e = window, a = 'inner';

  if (!('innerWidth' in window )) {
    a = 'client';
    e = document.documentElement || document.body;
  }

  return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
}

var $stickyAlert = $('.sticky-alert');
if($stickyAlert.length) {
  $stickyAlert.find('button').on('click', function() {
    $(this).closest('.sticky-alert').addClass('is-closed');
    if($('body').hasClass('gate') || $('body').hasClass('member-homepage')) {
        var CookieDate = new Date;
        CookieDate.setFullYear(CookieDate.getFullYear() +1)
        document.cookie = "covid=yes; expires="+ CookieDate.toUTCString() +"; path=/ ";
    }
  });
}


var $newWindowBody = $('.recommendation-body');
if($newWindowBody.length) {
    $( ".recommendation-body a" ).each( function( index, element ){
        if ($( this ).attr('href').indexOf("welltraveledclub.com") <= 0)
            $( this ).attr('target','_blank');
    });
}
